module.exports = __webpack_public_path__ + "img/Previeweyezen-start_smartphone.dd1af4a3.png";